import React from "react";
import CardHeader from "@material-ui/core/CardHeader";
import Avatar from "@material-ui/core/Avatar";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import Link from "@material-ui/core/Link";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Icon from "./Icon";
import { IS_DESKTOP } from "../util";
import IconButton from "@material-ui/core/IconButton";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    display: (props) => (props.isDesktop ? "block" : "flex"),
    flexDirection: (props) => (props.isDesktop ? "column" : "row-reverse"),
  },
  media: {
    height: (props) => (props.isDesktop ? spacing(30) : spacing(10)),
    width: (props) => props.isMobile && spacing(10),
    backgroundPosition: "inherit",
  },
  avatar: {
    backgroundColor: (props) => props.color,
    width: (props) => props.isMobile && spacing(3),
    height: (props) => props.isMobile && spacing(3),
  },
  cardHeaderAction: {
    marginTop: 0,
  },
  cardHeader: {
    flex: 1,
  },
}));

function Portal({ title, subheader, icon, href, image, color, ...props }) {
  const { root, media, avatar, cardHeaderAction, cardHeader } = useStyles({
    color: color,
    isDesktop: IS_DESKTOP(),
    isMobile: !IS_DESKTOP(),
  });

  return (
    <Card component={"article"} className={root} {...props}>
      <CardHeader
        avatar={
          IS_DESKTOP() && (
            <Avatar className={avatar}>
              <Icon name={icon} />
            </Avatar>
          )
        }
        disableTypography={!IS_DESKTOP()}
        title={
          <Typography variant={"body2"} display={"block"}>
            {title}
          </Typography>
        }
        subheader={
          <Typography variant={"body2"} color={"textSecondary"}>
            {subheader}
          </Typography>
        }
        action={
          <IconButton
            href={href}
            rel={"noreferrer nofollow noopener"}
            target={"_blank"}
          >
            <ChevronRightIcon />
          </IconButton>
        }
        classes={{ action: cardHeaderAction, root: cardHeader }}
      />
      <Link href={href}>
        <CardMedia
          className={media}
          image={image}
          title={`Banner para ${title}`}
        />
      </Link>
    </Card>
  );
}

export default Portal;
